var map = {
	"./bh-ico.svg": 789,
	"./bonus-ico.svg": 790,
	"./deposit-ico.svg": 791,
	"./deposit-ico.webp": 1827,
	"./edit-icon.svg": 792,
	"./fb-ico.svg": 793,
	"./instant-rebate-ico.svg": 794,
	"./mall-ico.svg": 795,
	"./msg-ico.svg": 796,
	"./pi-ico.svg": 797,
	"./rf-ico.svg": 798,
	"./rh-ico.svg": 799,
	"./th-ico.svg": 800,
	"./vip-ico.svg": 801,
	"./withdrawal-ico.svg": 802,
	"./withdrawal-ico.webp": 1828,
	"./wl-ico.svg": 803
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1826;